import CampaignsCreate from './views/campaigns/Create.vue';
import CampaignsEdit from './views/campaigns/Edit.vue';
import CampaignsIndex from './views/campaigns/Index.vue';
import Cookies from './views/Cookies.vue';
import E403 from './views/errors/E403.vue';
import E404 from './views/errors/E404.vue';
import ForgotPassword from './views/auth/ForgotPassword.vue';
import Impressum from './views/Impressum.vue';
import Login from './views/auth/Login.vue';
import Order from './views/Order.vue';
import Orders from './views/orders/Index.vue';
import OrdersByProduct from './views/orders/ByProduct.vue';
import OrdersByUser from './views/orders/ByUser.vue';
import OrdersDaily from './views/orders/Daily.vue';
import OrdersTable from './views/orders/Table.vue';
import PaymentStatus from './views/payments/Status.vue';
import PaymentsByWeek from './views/payments/ByWeek.vue';
import PaymentsPaged from './views/payments/Paged.vue';
import PreviousOrders from './views/PreviousOrders.vue';
import Privacy from './views/Privacy.vue';
import ProductsAvailability from './views/products/Availability.vue';
import ProductsBase from './views/products/Base.vue';
import ProductsCreate from './views/products/Create.vue';
import ProductsEdit from './views/products/Edit.vue';
import ProductsIndex from './views/products/Index.vue';
import Profile from './views/auth/Profile.vue';
import Register from './views/auth/Register.vue';
import ResetPassword from './views/auth/ResetPassword.vue';
import ResetPasswordCode from './views/auth/ResetPasswordCode.vue';
import Settings from './views/admin/Settings.vue';
import Terms from './views/Terms.vue';
import UsersCreate from './views/users/Create.vue';
import UsersEdit from './views/users/Edit.vue';
import UsersIndex from './views/users/Index.vue';
import UserGroupsCreate from './views/userGroups/Create.vue';
import UserGroupsEdit from './views/userGroups/Edit.vue';
import UserGroupsIndex from './views/userGroups/Index.vue';
import Welcome from './views/Welcome.vue';

export const routes = [
    {
        component: Welcome,
        meta: {
            requiresAuth: false
        },
        name: 'welcome',
        path: '/',
    },
    {
        component: Cookies,
        meta: {
            requiresAuth: false
        },
        name: 'cookies',
        path: '/cookies',
    },
    {
        component: Impressum,
        meta: {
            requiresAuth: false
        },
        name: 'impressum',
        path: '/impressum',
    },
    {
        component: Privacy,
        meta: {
            requiresAuth: false
        },
        name: 'privacy',
        path: '/privacy-policy',
    },
    {
        component: Terms,
        meta: {
            requiresAuth: false
        },
        name: 'terms',
        path: '/terms',
    },
    {
        component: CampaignsCreate,
        meta: {
            requiresAuth: true
        },
        name: 'campaigns.create',
        path: '/campaigns/create',
    },
    {
        component: CampaignsEdit,
        meta: {
            requiresAuth: true
        },
        name: 'campaigns.edit',
        path: '/campaigns/:campaign/edit',
    },
    {
        component: CampaignsIndex,
        meta: {
            requiresAuth: true
        },
        name: 'campaigns',
        path: '/campaigns',
    },
    {
        component: Login,
        meta: {
            requiresAuth: false
        },
        name: 'login',
        path: '/login',
    },
    {
        component: Order,
        meta: {
            requiresAuth: true
        },
        name: 'order',
        path: '/order',
    },
    {
        component: Orders,
        meta: {
            requiresAuth: true
        },
        name: 'orders',
        path: '/orders',
    },
    {
        component: OrdersByProduct,
        meta: {
            requiresAuth: true
        },
        name: 'orders.byproduct',
        path: '/orders/byproduct',
    },
    {
        component: OrdersByUser,
        meta: {
            requiresAuth: true
        },
        name: 'orders.byuser',
        path: '/orders/byuser',
    },
    {
        component: OrdersDaily,
        meta: {
            requiresAuth: true
        },
        name: 'orders.daily',
        path: '/orders/daily',
    },
    {
        component: OrdersTable,
        meta: {
            requiresAuth: true
        },
        name: 'orders.table',
        path: '/orders/table',
    },
    {
        component: ForgotPassword,
        meta: {
            requiresAuth: false
        },
        name: 'forgot-password',
        path: '/password/reset',
    },
    {
        component: PreviousOrders,
        meta: {
            requiresAuth: true
        },
        name: 'order.previous',
        path: '/order/previous',
    },
    {
        component: PaymentsByWeek,
        meta: {
            requiresAuth: true
        },
        name: 'payments',
        path: '/payments',
    },
    {
        component: PaymentsPaged,
        meta: {
            requiresAuth: true
        },
        name: 'payments.paged',
        path: '/payments/paged',
    },
    {
        component: PaymentStatus,
        meta: {
            requiresAuth: true
        },
        name: 'payments.status',
        path: '/payments/status',
    },
    {
        component: ProductsAvailability,
        meta: {
            requiresAuth: true
        },
        name: 'products.availability',
        path: '/products/availability',
    },
    {
        component: ProductsBase,
        meta: {
            requiresAuth: true
        },
        name: 'products.base',
        path: '/products/base',
    },
    {
        component: ProductsCreate,
        meta: {
            requiresAuth: true
        },
        name: 'products.create',
        path: '/products/create',
    },
    {
        component: ProductsEdit,
        meta: {
            requiresAuth: true
        },
        name: 'products.edit',
        path: '/products/:product/edit',
    },
    {
        component: ProductsIndex,
        meta: {
            requiresAuth: true
        },
        name: 'products',
        path: '/products',
    },
    {
        component: Profile,
        meta: {
            requiresAuth: true
        },
        name: 'profile',
        path: '/profile',
    },
    {
        component: Register,
        meta: {
            requiresAuth: false
        },
        name: 'register',
        path: '/register',
    },
    {
        component: ResetPasswordCode,
        meta: {
            requiresAuth: false
        },
        name: 'password-email',
        path: '/password/email',
    },
    {
        component: ResetPassword,
        meta: {
            requiresAuth: false
        },
        name: 'reset-password',
        path: '/password/reset/:token',
    },
    {
        component: Settings,
        meta: {
            requiresAuth: true
        },
        name: 'admin.settings',
        path: '/admin/settings',
    },
    {
        component: UsersCreate,
        meta: {
            requiresAuth: true
        },
        name: 'users.create',
        path: '/users/create',
    },
    {
        component: UsersEdit,
        meta: {
            requiresAuth: true
        },
        name: 'users.edit',
        path: '/users/:user/edit',
    },
    {
        component: UsersIndex,
        meta: {
            requiresAuth: true
        },
        name: 'users',
        path: '/users',
    },
    {
        component: UserGroupsCreate,
        meta: {
            requiresAuth: true
        },
        name: 'users.groups.create',
        path: '/users/groups/create',
    },
    {
        component: UserGroupsEdit,
        meta: {
            requiresAuth: true
        },
        name: 'users.groups.edit',
        path: '/users/groups/:group/edit',
    },
    {
        component: UserGroupsIndex,
        meta: {
            requiresAuth: true
        },
        name: 'users.groups',
        path: '/users/groups',
    },
    {
        component: E403,
        name: 'errors.403',
        path: '/unauthorized',
    },
    {
        component: E404,
        meta: {
            requiresAuth: false
        },
        name: 'errors.404',
        path: '/:pathMatch(.*)*',
    },
];